export default __webpack_public_path__ + "static/media/NUTRICION_VEGETAL.6ddcbead.jpg";